import dayjs from 'dayjs';

export default function momentSecondsSince(date: Date) {
  if (!date) {
    return '';
  }

  return dayjs().diff(date, 'seconds');
}
